import { SubjectDto, SubjectRestControllerService } from 'generated';
import { useCallback, useState } from 'react';
import { apiWrapper } from 'utils/http-client';
import useLoading from 'utils/useLoading/useLoading';
import { handleError } from 'utils/utils';

const useSubjectGet = () => {
  const { loading, startLoading, stopLoading } = useLoading();
  const [content, setContent] = useState<SubjectDto>({});

  const fetchSubjectById = useCallback(
    async (id: string) => {
      startLoading();
      try {
        const response = await apiWrapper(() =>
          SubjectRestControllerService.getSubjectUsingGet({
            id,
          }),
        );
        setContent(response);
        stopLoading();
      } catch (error) {
        handleError(error);
        stopLoading();
        setContent({});
      }
    },
    [startLoading, stopLoading],
  );

  return {
    fetchSubjectById,
    loadingSubject: loading,
    subjectDetail: content,
  };
};

export default useSubjectGet;
